/**
 * Transport availability for the Todo/Alarm section.
 *
 * Demo mode uses the in-memory mock client. Live mode reaches the daemon over
 * the E2E relay since v0.6.0: `todo.request`/`alarm.request` are dispatched by
 * the daemon bridge to the same repositories as `/todos` and `/alarms`, so a
 * paired PWA/Android WebView can CRUD without loopback HTTP.
 *
 * Availability only reports configuration gaps (paired + live relay plan); real
 * daemon errors are surfaced verbatim by the request path, never faked.
 */

export interface TodoAlarmAvailability {
  available: boolean;
  reason?: string;
}

export function todoAlarmAvailability(input: {
  hasClient: boolean;
  demoMode: boolean;
  paired: boolean;
  /** Live relay plan is enabled (ignored when `hasClient` is true). */
  relayEnabled?: boolean;
  relayReason?: string;
}): TodoAlarmAvailability {
  if (input.hasClient) return { available: true };
  if (input.demoMode) {
    return {
      available: false,
      reason: '演示模式尚未初始化本地设备，请先完成配对以启用待办/闹钟演示数据。',
    };
  }
  if (!input.paired) {
    return { available: false, reason: '待办与闹钟需要通过已配对的 daemon 访问（请先配对）。' };
  }
  if (input.relayEnabled !== true) {
    return {
      available: false,
      reason: `live relay 未就绪，无法访问 daemon 的待办/闹钟接口：${input.relayReason ?? '未配置'}`,
    };
  }
  return { available: true };
}
